import React, { useEffect, useState } from 'react';

// free-exercise-db demonstration: two photos (start / end position) shown
// alternately so the client sees the movement. Falls back to a single image
// for older records that only have `animation_url`.
export const ExerciseDemo = ({ exercise, className = '', interval = 1000, animate = true }) => {
  const frames = exercise?.animation_frames?.length
    ? exercise.animation_frames
    : exercise?.animation_url ? [exercise.animation_url] : [];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    setIndex(0);
    if (!animate || frames.length < 2) return undefined;
    const id = setInterval(() => setIndex(i => (i + 1) % frames.length), interval);
    return () => clearInterval(id);
  }, [animate, frames.length, interval, frames[0]]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!frames.length) return null;

  return (
    <div className={`relative w-full aspect-[3/2] overflow-hidden rounded-3xl bg-[#1E1E1E] ${className}`} data-testid="exercise-animation">
      {frames.map((src, i) => (
        <img
          key={src}
          src={src}
          alt={i === 0 ? `Jak wykonać: ${exercise.name}` : ''}
          loading={animate ? "eager" : "lazy"}
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-300"
          style={{ opacity: i === index ? 1 : 0 }}
        />
      ))}
    </div>
  );
};
